import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-222c5939"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profiles-list" }

import ProfileCard from "@/common/ProfileCard.vue";
import {PropType} from "vue";
import ProfileCardInterface from "@/common/types/ProfileCardInterface";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfilesList',
  props: {
  cards: {
    type: Array as PropType<Array<ProfileCardInterface>>,
    required: true,
  },
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cards, (card) => {
      return (_openBlock(), _createBlock(ProfileCard, {
        card: card,
        key: card.id
      }, null, 8 /* PROPS */, ["card"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}
}

})